export default {
  currentPersonInfo: {},
  currentAppAuthsInOrg: [],
  currentOrg: {},
  updateNavPageFlag: 0,
  selectOrgTree: [],
  appsInOrg: [],
  pcCommonData: {},
  currentMicroApps: [],
  appsInOrgs: [],
  keycloakToken: {
    tokenParsed: {
      attributes: {},
    },
  },
  tabs: [],
  iframes: [],
  loadedMicroApps: {}, // 已手动加载的微应用
  loadExternalApps: [],
  tabMenu: {
    status: 'none',
    top: '0px',
    left: '0px',
    list: [],
  },
}
